// Styled Components
import styled from "styled-components";

// Material UI
// import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { FiberManualRecord } from "@material-ui/icons";

// React Slick
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Carousel = () => {
  // Slider Settings
  const settings = {
    dots: false,
    infinite: true,
    speed: 750,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: false,
    swipe: true,
    arrows: false,
    autoplaySpeed: 5000,
    customPaging: () => <FiberManualRecord />,
  };

  return (
    <Wrapper {...settings}>
      <div className="slide-1">
        <img
          src="https://cdn.discordapp.com/attachments/896285560094748713/898305820620628028/Waves199.jpg"
          alt=""
        />
      </div>
      <div className="slide-2">
        <img
          src="https://cdn.discordapp.com/attachments/896285560094748713/898305868284702801/REDNER_THIS_ONE_3199.jpg"
          alt=""
        />
      </div>
      <div className="slide-3">
        <img
          src="https://cdn.discordapp.com/attachments/896285560094748713/898305934152040478/WANF_Blue199.jpg"
          alt=""
        />
      </div>
      <div className="slide-4">
        <img
          src="https://cdn.discordapp.com/attachments/896285560094748713/898305965898756146/WANF_Black199.jpg"
          alt=""
        />
      </div>
      <div className="slide-5">
        <img
          src="https://cdn.discordapp.com/attachments/896285560094748713/898305997087580210/presto199.jpg"
          alt=""
        />
      </div>
      <div className="slide-6">
        <img
          src="https://cdn.discordapp.com/attachments/896285560094748713/898306024392503316/PNS199.jpg"
          alt=""
        />
      </div>
      <div className="slide-7">
        <img
          src="https://cdn.discordapp.com/attachments/896285560094748713/898306054297907230/niceday199.jpg"
          alt=""
        />
      </div>
      <div className="slide-8">
        <img
          src="https://cdn.discordapp.com/attachments/896285560094748713/898306078830391376/marge199.jpg"
          alt=""
        />
      </div>
      <div className="slide-9">
        <img
          src="https://cdn.discordapp.com/attachments/896285560094748713/898306135818383360/justice199.jpg"
          alt=""
        />
      </div>
      <div className="slide-10">
        <img
          src="https://cdn.discordapp.com/attachments/896285560094748713/898306161978249236/Human199.jpg"
          alt=""
        />
      </div>
      <div className="slide-11">
        <img
          src="https://cdn.discordapp.com/attachments/896285560094748713/898306197323653160/god199.jpg"
          alt=""
        />
      </div>
      <div className="slide-12">
        <img
          src="https://cdn.discordapp.com/attachments/896285560094748713/898306225819770910/chicago199.jpg"
          alt=""
        />
      </div>
      <div className="slide-13">
        <img
          src="https://cdn.discordapp.com/attachments/896285560094748713/898306280693846036/astro199.jpg"
          alt=""
        />
      </div>
      <div className="slide-14">
        <img
          src="https://cdn.discordapp.com/attachments/896285560094748713/898306225819770910/chicago199.jpg"
          alt=""
        />
      </div>
      <div className="slide-15">
        <img
          src="https://cdn.discordapp.com/attachments/896285560094748713/898306318438387762/anymeans199.jpg"
          alt=""
        />
      </div>
    </Wrapper>
  );
};

export default Carousel;

const Wrapper = styled(Slider)`
  padding: 0 4%;
  padding-top: 100px;

  div {
    img {
      width: 100%;
    }
  }
  .slick-slide div {
    outline: none;
    border: 1px solid transparent;
  }

  .slick-slide > div {
    display: grid;
    place-items: center;
    width: 95%;

    margin: auto;
  }

  .slick-list {
    overflow: initial;
  }
`;
